import { trpc } from '../lib/trpc';
import { useAsync } from '../lib/useAsync';
import { Loading, ErrorBox } from '../components/admin/ui';
import { mesLabel } from '../lib/format';
import { CardInccVigente } from '../components/CardInccVigente';

/**
 * Índice INCC — visão da INCORPORADORA (Área do Cliente). READ-ONLY: consulta o
 * índice que reajusta os contratos. A manutenção da série é AUTOMÁTICA (job do
 * SGS/Banco Central); a incorporadora só consulta, não lança. Índice nacional,
 * sem dado de tenant (procedure protected lendo a série global).
 */

function fmtPct(v: string | number): string {
  const n = Number(v);
  return `${n > 0 ? '+' : ''}${n.toFixed(2).replace('.', ',')}%`;
}

export function IndiceIncc() {
  const { data, loading, error, reload } = useAsync(() => trpc.incc.serie.query());

  return (
    <div className="mx-auto max-w-3xl" data-testid="indice-incc-page">
      <h1 className="text-2xl font-semibold text-ink">Índice INCC</h1>
      <p className="mt-1 text-sm text-ink-3">
        O índice que reajusta seus contratos. Atualizado automaticamente pela plataforma.
      </p>

      <div className="mt-4">
        <CardInccVigente />
      </div>

      <div className="mt-4">
        {loading && <Loading />}
        {error && <ErrorBox msg={error} onRetry={reload} />}
        {data && data.length === 0 && (
          <div className="card p-6 text-center text-sm text-ink-3">
            A série do INCC ainda está sendo carregada. Assim que a plataforma buscar os índices, eles aparecem aqui.
          </div>
        )}
        {data && data.length > 0 && (
          <div className="card overflow-hidden">
            <div className="border-b border-line px-5 py-3 text-[15px] font-semibold text-ink">
              Série INCC ({data.length} {data.length === 1 ? 'mês' : 'meses'})
            </div>
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-line text-left text-xs text-ink-3">
                  <th className="px-5 py-2 font-medium">Mês</th>
                  <th className="px-3 py-2 font-medium">Variação</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-line">
                {data.map((i) => (
                  <tr key={i.anoMes} data-testid="incc-serie-linha">
                    <td className="px-5 py-2.5 text-ink">{mesLabel(i.anoMes)}</td>
                    <td className="num px-3 py-2.5" style={{ color: Number(i.variacaoPercentual) < 0 ? 'var(--risk)' : 'var(--ink)' }}>
                      {fmtPct(i.variacaoPercentual)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
